import React, { useState, useEffect } from "react"
import { Layout, Menu, Select, Switch, Tabs } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";


const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const LogMood
    = () => {

        const [modal1Open, setModal1Open] = useState(false);


        const navigate = useNavigate()

        // switch
        const onChange3 = (checked) => {
            console.log(`switch to ${checked}`);
        };

        //   


        useEffect(() => {
            document.title = 'MentalFit';
        }, [])



        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Log Mood</h1>
                            <Breadcrumb separator=">">

                                <Breadcrumb.Item>
                                    <Link to="/tools"> Tools </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {appconstant.logMood}
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </div>



                    <section>
                        <div className=" manage-table-data">
                            <div className="log-moode-page-sec">
                                <div className="log-mood">
                                    <div onClick={() => { setModal1Open(true) }} className="new-mood-add">
                                        <div className="add-image-mood">
                                            <img src={images.logMood} alt="logMood" />
                                        </div>
                                        <div className="new-mood-text">
                                            <p><span> <img src={images.add} alt="add" /></span>Add new Mood</p>
                                        </div>
                                    </div>

                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.bestMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Best Possible</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.greatMood} alt="greatMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Great</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.veryBestMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Very Good</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.goodMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1> Good</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.prettyMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Pretty Good</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.okMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>OK</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.betterMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Been Better</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.badMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Bad</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.veryBadMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Very Bad</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.mostWorstMood} alt="bestMood" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Worst Possible</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </section>



                </div>

                {/* Add new Widget */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal1Open}
                    closable={true}
                    onCancel={() => setModal1Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user font-size-inc">
                            <h1>Add new Mood </h1>
                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group">
                                    <label>{appconstant.emotionTitle}</label>
                                    <Textfiled
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Emotion Title'
                                    />
                                </div>




                            </div>
                        </div>


                        <div className="upload-widget-icon">
                            <div className="click-to-upload">
                                <label>Upload Emotion Icon</label>
                                <div className="upload-file new-up-file emoji-possible">
                                    <div className="upload-center-text add-widget-activity">
                                        <p><span><img src={images.upload} alt="upload" /></span> Click here to upload</p>
                                    </div>
                                    <p className="image-disp">File Format: .JPEG, .PNG</p>
                                </div>
                            </div>
                        </div>

                        <div className="best-png">
                            <div className="relationship">
                                <p><span><img className="best-emoji-mod" src={images.bestMood} alt=""/></span> Best Possible .PNG<span><img src={images.singleCross} alt="singleCross" /></span></p>
                            </div>

                        </div>

                        <div className="click-to-upload">
                            <div className="add-activity-button">
                                <button>Add Mood</button>
                            </div>
                        </div>

                    </div>
                </Modal>


            </div>

        )
    }
export default LogMood

